import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Reports TYPE chip — Figma: 6px radius, stroke/200, structural/100. */
export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: ${spacing[1]} 10px;
  border-radius: ${borderRadius.md};
  border: 1px solid ${rawColors.stroke[200]};
  background-color: ${rawColors.structural[100]};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
  white-space: nowrap;
`;
